import { render } from "./TheStationsSiemensRecharges.vue?vue&type=template&id=7f447fc1"
const script = {}

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__